import { ChangeDetectorRef, Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IComboBase } from '../../../interfaces/base/base.interface';
import { EmployeeLocalService } from '../../services/employee.service';
import { ActivatedRoute, Router } from '@angular/router';
import { getYearOptions, monthOptions } from '../../../utils/helpers';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-cesados-detail',
  templateUrl: './cesados-detail.component.html',
  styleUrl: './cesados-detail.component.scss'
})
export class CesadosDetailComponent {
  tabs = [
    { key: '1', text: 'Documentos' },
    { key: '2', text: 'Histórico' },
  ];

  selectedTabKey: number = 1;
  detailContract: any = null;
  historyContract: any[] = [];
  isLoading: boolean = false;
  isLoadingHistory: boolean = false;
  pageIndex: number = 0;
  pageSize: number = 10;
  totalElements: number = 0;
  selectedDocument: SafeResourceUrl | null = null;
  selectedContractIndex: number | null = null;
  isSelected: boolean[] = [];
  noDocumentMessage: string | null = null;

  dataToEdit: any = null;
  mostrarModalValidar: boolean = false;

  // MES
  monthOptions: IComboBase[] = [{ key: '00', text: 'Todos' }, ...monthOptions];
  currentMonth: IComboBase | null = null;
  selectedMonth: IComboBase | null = null;

  // AÑO
  yearOptions: IComboBase[] = [];
  selectedYear: IComboBase | null = null;

  // Término de búsqueda
  searchTerm = '';

  // dataSource: any[] = [];
  displayedColumns = [
    { key: 'companyName', header: 'Empresa' },
    { key: 'jobPositionName', header: 'Cargo' },
    { key: 'salary', header: 'Sueldo' },
    { key: 'startDateContract', header: 'Fecha Inicio' },
    { key: 'endDateContract', header: 'Fecha Fin' },
    { key: 'typeContractName', header: 'Tipo' },
    { key: 'stateContract', header: 'Status' },
  ];

  actionButtons = [
    {
      icon: (row: any) =>
        row.stateContractId === 3 ? 'pi pi-eye' : 'pi pi-check-square',
      color: '#ED672A',
      tooltip: (row: any) =>
        row.stateContractId === 3 ? 'Detalle' : 'Validar',
      action: (row: any) => {
        this.dataToEdit = {
          ...row,
        };
        this.mostrarModalValidar = true;
      },
      visible: (row: any) => true,
    },
  ];

  // Fila seleccionada
  selectedRowId: number | null = null;

  constructor(
    private employeeLocalService: EmployeeLocalService,
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {
    this.currentMonth = this.monthOptions[0];
    this.selectedMonth = { key: '00', text: 'Todos' };

    this.yearOptions = getYearOptions();
    this.selectedYear = this.yearOptions.find((y) => y.key === new Date().getFullYear().toString()) || null;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const employeeId = params.get('id');
      this.isLoading = true;
      this.isLoadingHistory = true;

      this.employeeLocalService
        .getContractDetailByEmployeeId(Number(employeeId))
        .subscribe({
          next: (data) => {
            this.detailContract = data;
            this.detailContract.startDateEmployee = this.convertToDate(
              this.detailContract.startDateEmployee
            );
            if (this.detailContract?.contracts) {
              this.detailContract.contracts.forEach((contract: any) => {
                contract.startDateContract = this.convertToDate(
                  contract.startDateContract
                );
              });

              this.isSelected = new Array(
                this.detailContract.contracts.length
              ).fill(false);
            }
            this.isLoading = false;
          },
          error: (err) => {
            console.error(
              'Error al obtener la lista de contratos por empleado:',
              err
            );
            this.isLoading = false;
          },
        });

      this.filterData(Number(employeeId));
    });
  }

  filterData(employeeId: number, resetPage: boolean = false): void {
    if (resetPage) {
      this.pageIndex = 0;
    }

    this.isLoadingHistory = true;

    const filters = {
      search: this.searchTerm || null,
      month: this.selectedMonth?.key == '00' ? null : this.selectedMonth?.key,
      year: this.selectedYear?.key || null,
      page: this.pageIndex,
      size: this.pageSize,
    };

    this.employeeLocalService
      .postContractHistoryByEmployeeId(employeeId, filters)
      .subscribe({
        next: (response) => {
          this.historyContract = response.content;
          this.pageIndex = response.page.page;
          this.pageSize = response.page.size;
          this.totalElements = response.page.totalElements;
          this.isLoadingHistory = false;
        },
        error: (err) => {
          console.error('Error al obtener la historia de contratos:', err);
          this.isLoadingHistory = false;
        },
      });
  }

  onContractSelect(index: number, fileContract: string | null): void {
    if (!fileContract) {
      this.selectedDocument = null;
      this.isSelected.fill(false);
      this.isSelected[index] = true;
      this.noDocumentMessage =
        'No cuenta con documento debido a que no ha sido renovado.';
      return;
    } else if (fileContract === '') {
      this.selectedDocument = null;
      this.noDocumentMessage = 'No se ha adjuntado el contrato aún.';
    } else {
      this.selectedDocument =
        this.sanitizer.bypassSecurityTrustResourceUrl(fileContract);
      this.noDocumentMessage = null;
    }

    this.noDocumentMessage = null;
    this.isSelected.fill(false);
    this.isSelected[index] = true;
    this.selectedDocument =
      this.sanitizer.bypassSecurityTrustResourceUrl(fileContract);
    this.isLoading = false;
  }

  getStatusClass(status: number): string {
    switch (status) {
      case 1: // No renovado
        return 'status-not-renewed';
      case 2: // Enviado
        return 'status-sent';
      case 3: // Firmado
        return 'status-signed';
      case 4: // Pendiente
        return 'status-pending';
      default:
        return 'status-default';
    }
  }

  onTabSelected(index: number): void {
    const selectedTab = this.tabs[index];
    if (selectedTab) {
      this.selectedTabKey = Number(selectedTab.key);
    }
  }

  onRowSelected(row: any): void {
    this.selectedRowId = row.contractId;
  }

  onDocumentLoad(): void {
    this.isLoading = false;
  }

  onDocumentError(): void {
    this.isLoading = false;
    this.selectedDocument = null;
  }

  convertToDate(dateString: string): Date {
    const [day, month, year] = dateString.split('/');
    return new Date(+year, +month - 1, +day);
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';

    // Mapeo de nombres de meses en inglés a números
    const monthsMap: { [key: string]: string } = {
      January: '01',
      February: '02',
      March: '03',
      April: '04',
      May: '05',
      June: '06',
      July: '07',
      August: '08',
      September: '09',
      October: '10',
      November: '11',
      December: '12',
    };

    // Extraer los datos de la fecha usando una expresión regular
    const dateParts = dateString.match(/(\w+)\s(\d+)\sdel\s(\d+)/);
    if (!dateParts) return dateString;

    const month = monthsMap[dateParts[1]];
    const day = dateParts[2].padStart(2, '0');
    const year = dateParts[3].slice(-2);

    return `${day}/${month}/${year}`;
  }

  onMonthChange(selected: IComboBase): void {
    this.selectedMonth = selected;
    const employeeId = this.route.snapshot.paramMap.get('id');
    this.filterData(Number(employeeId), true);
  }

  onSearch(query: string): void {
    this.searchTerm = query;
    const employeeId = this.route.snapshot.paramMap.get('id');
    this.filterData(Number(employeeId), true);
  }

  onYearChange(selected: IComboBase): void {
    this.selectedYear = selected;
    const employeeId = this.route.snapshot.paramMap.get('id');
    this.filterData(Number(employeeId), true);
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    const employeeId = this.route.snapshot.paramMap.get('id');
    this.filterData(Number(employeeId));
  }

  onNewRenewalContract(): void {
    const employeeId = this.route.snapshot.paramMap.get('id');

    this.router.navigate(['/dashboard/employee/cesados/reactivate'], {
      state: { employeeId: employeeId },
    });

    console.log('employeeId DETALLE:' + employeeId);
  }

  onDialogValidateClose() {
    this.mostrarModalValidar = false;
  }

  onUpdateStateComplete(): void {
    const employeeId = this.route.snapshot.paramMap.get('id');
    this.filterData(Number(employeeId));
  }

  goBack() {
    this.router.navigate(['/dashboard/employee/cesados']);
  }
}

